import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Close, DoubleChevronDown, DoubleChevronUp, Pause, Play } from "@air/next-icons";
import { memo } from "react";
import { FileStatus } from "../../constants/FileStatus";
import { FileStatusButton } from "./FileStatusButton";
export const FileStatusPanelHeaderButtons = /*#__PURE__*/ memo((param)=>{
    let { onDismiss, onPause, onResume, status, onCancel, isUploaderOpen, onToggle, disableCancel } = param;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            onPause && status === FileStatus.progressing && /*#__PURE__*/ _jsx(FileStatusButton, {
                label: "Pause",
                onClick: onPause,
                children: /*#__PURE__*/ _jsx(Pause, {
                    className: "size-4"
                })
            }),
            onResume && status === FileStatus.paused && /*#__PURE__*/ _jsx(FileStatusButton, {
                label: "Resume",
                onClick: onResume,
                children: /*#__PURE__*/ _jsx(Play, {
                    className: "size-4"
                })
            }),
            isUploaderOpen ? /*#__PURE__*/ _jsx(FileStatusButton, {
                label: "Minimize",
                onClick: ()=>onToggle(false),
                children: /*#__PURE__*/ _jsx(DoubleChevronDown, {
                    className: "size-4"
                })
            }) : /*#__PURE__*/ _jsx(FileStatusButton, {
                label: "Expand",
                onClick: ()=>onToggle(true),
                children: /*#__PURE__*/ _jsx(DoubleChevronUp, {
                    className: "size-4"
                })
            }),
            onDismiss && (disableCancel || status === FileStatus.completed) && /*#__PURE__*/ _jsx(FileStatusButton, {
                "data-testid": "CLOSE_UPLOADS_BUTTON",
                label: "Close",
                onClick: onDismiss,
                children: /*#__PURE__*/ _jsx(Close, {
                    className: "size-4"
                })
            }),
            onCancel && status !== FileStatus.completed && /*#__PURE__*/ _jsx(FileStatusButton, {
                label: "Cancel",
                onClick: onCancel,
                children: /*#__PURE__*/ _jsx(Close, {
                    className: "size-4"
                })
            })
        ]
    });
});
FileStatusPanelHeaderButtons.displayName = "FileStatusPanelHeaderButtons";
